import { useEffect, useState } from 'react';
import { OrganizationsApi } from '@/api/clients/organizations/organizations.api';

export const useGetOrganizations = () => {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchOrganizations = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await OrganizationsApi.getOrganizations();
      setOrganizations(data.organizations);
    } catch (error) {
      setError(error);
      console.error('Error fetching organizations:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrganizations();
  }, []);

  return {
    organizations,
    loading,
    error,
    refetch: fetchOrganizations,
  };
};
